// Common QA automation tags
export const SUGGESTED_TAGS = [
  // Test Types
  "smoke",
  "regression",
  "integration",
  "e2e",
  "unit",
  "sanity",
  // Functional Areas
  "auth",
  "payment",
  "navigation",
  "form",
  "api",
  "ui",
  "search",
  "checkout",
  // Non-functional
  "performance",
  "security",
  "accessibility",
  "usability",
  "load",
  // Status
  "flaky",
  "stable",
  "new",
  "deprecated",
  "wip",
  "blocked",
];
